
import React from 'react';
import { FiMapPin, FiPlusCircle, FiTrash2 } from 'react-icons/fi';
import { ProcessHeader } from '../../../../components';
import './styles.css';

function useUserAddresses(commands){
    const delAddr = (id, selected) => {
      commands.deleteAddress(id);
      if (id === selected) commands.order.changeDataAttributes({
        deliveryAddr: {},
        deliveryAddrId: undefined,
        deliveryValue: undefined,
      });
    }

    const selectAddress = (address, gratuity, order) => {
      const free = Number(address.distance?.value) < gratuity*1000 || order.freeFreight.minOrderValue || order.freeFreight.daysOfWeek
      commands.order.changeDataAttributes({
      deliveryAddr: address,
      deliveryAddrId:address.id,
      distanceText: address?.distance?.text,
      deliveryValue:  free ? 0 : address.cost,
      freeFreight: {...order.freeFreight, kilometerRadius: free ?? undefined}
    });
    commands.process.goToStep(3);
  }; 

    const registerNewAddress = () => {
      commands.order.changeDataAttributes({
        deliveryAddr: {},
        deliveryAddrId:0,
        deliveryValue: undefined
      });
      commands.process.updateMultipleDataControllers(
        {
          newAddress: true,
          newAddressFromAddressesList: true,
        });
  }; 

  const goBack = () => commands.process.previousStep();
  return ({
    eventHandlers:{
      delAddr,
      selectAddress,
      registerNewAddress,
      goBack
    },
  });
}

export default function UserAddresses(props) {
  const {commands, sharedStates, remoteStates, metaStates} = props;
  const {eventHandlers} = useUserAddresses(commands);
    
    return (
      <section className="step-container">
        <ProcessHeader goBackAction={eventHandlers.goBack}/>
        <h1 className="step-title">
          Em qual dos endereços você prefere receber o produto?
        </h1>
        {
        remoteStates.addresses?.map((item, index) => (
          <div className="step-options-items" key={index}>
            <div className={`step-option-select ${item.id === sharedStates?.order?.deliveryAddrId && 'step-option-selected'}`}>
            <button
              type="button"
              onClick={Object.values(metaStates).every((item)=>!item) ? ()=>eventHandlers.selectAddress(item, sharedStates?.gratuity, sharedStates?.order) :()=>{}}
              className='step-option-selector'
            >
              <div className="step-option-delivery-values-box">
                <FiMapPin size={32} strokeWidth="0.8" />
                <p className="delivery-value">{item.neighborhood}</p>
                { 
                Number(item?.distance?.value) < sharedStates?.gratuity*1000 
                || sharedStates.order.freeFreight.minOrderValue 
                || sharedStates.order.freeFreight.daysOfWeek
                  ? <p className="delivery-free">Grátis</p>
                  :<>
                    <p className="delivery-distance">{item?.distance?.text ?? 'Calculando...'}</p>
                    <p className="delivery-value">{isNaN(item.cost) ? '' : Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.cost)}</p>
                  </>
                }
              </div>

              <div className="step-option-text">
                <p>{`${item.street}, ${item.number} ${item.complement ? `(${item.complement})` : ''}`}</p>
                <p>{`${item.city}/${item.uf}`}</p>
                <p>{`CEP: ${item.zipCode}`}</p>
              </div>
              </button>
              <FiTrash2 size={24} strokeWidth="1" className="del-icon" onClick={() => eventHandlers.delAddr(item.id, sharedStates?.order?.deliveryAddrId)} />
            </div>
          </div>
        )
        )
        }
        {
          !remoteStates.addresses && <p>(Você ainda não possui endereços)</p>
        }
        <button className="no-style-button" onClick={eventHandlers.registerNewAddress}>
          <FiPlusCircle size={42} strokeWidth="0.8" color="#888" />
        </button>
      </section>
    );
}

